var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "popup", staticStyle: { "z-index": "600" } },
        [
          _c(
            "div",
            { staticClass: "content", attrs: { id: "editCloudNotic" } },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("language.popup.note")) +
                    "\n               "
                ),
                _c("div", {
                  staticClass: "icon white-close dialog-close",
                  on: {
                    click: function($event) {
                      _vm.isShow = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "editCloudNotic-body" }, [
                _c("div", { staticClass: "editCloudNotic-info" }, [
                  _vm._v(
                    "\n                      " +
                      _vm._s(
                        _vm.$t("language.popup.editCloudNoticPopup.tips")
                      ) +
                      "\n                 "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "editCloudNotic-bottom" }, [
                  _c(
                    "button",
                    {
                      staticStyle: {
                        "min-width": "110Px",
                        float: "right",
                        padding: "0 20px"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.rewriteDrive()
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("language.popup.editCloudNoticPopup.btnTxt")
                          )
                      )
                    ]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("editCloudResotreDialog", {
            ref: "editCloudResotreDialog",
            staticStyle: { "z-index": "601" },
            attrs: { cloudType: _vm.cloudName, cloudId: _vm.cloudId }
          }),
          _vm._v(" "),
          _c("editFtpDialog", {
            ref: "editFtpDialog",
            staticStyle: { "z-index": "601" }
          }),
          _vm._v(" "),
          _c("editNasDialog", {
            ref: "editNasDialog",
            staticStyle: { "z-index": "601" }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51ce8d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ce8d10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/edit_cloud_notic_popup.vue
// module id = null
// module chunks = 